var m = (e) => {
  const i = e.staleTime;
  e.suspense && (e.staleTime = typeof i == "function" ? (...c) => Math.max(i(...c), 1e3) : Math.max(i ?? 1e3, 1e3), typeof e.gcTime == "number" && (e.gcTime = Math.max(e.gcTime, 1e3)));
}, s = (e, i) => e.isLoading && e.isFetching && !i, h = (e, i) => (e == null ? void 0 : e.suspense) && i.isPending, r = (e, i, c) => i.fetchOptimistic(e).catch(() => {
  c.clearReset();
});
export {
  m as ensureSuspenseTimers,
  r as fetchOptimistic,
  h as shouldSuspend,
  s as willFetch
};
//# sourceMappingURL=contact-channels174.js.map
